import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/open-zi.svg';
import _imports_1 from '@/assets/images/icons/link2-zi.svg';
import _imports_2 from '@/assets/images/icons/tip.svg';
const _withScopeId = n => (_pushScopeId("data-v-32946d8e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dashboard-card border-radius-20 pl-4 pr-4 pt-3 pb-3"
};
const _hoisted_2 = {
  class: "d-flex flex-row mb-3 justify-content-between align-items-center"
};
const _hoisted_3 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4"
}, null, -1));
const _hoisted_5 = {
  class: "mb-4"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-lg-6 col-12"
};
const _hoisted_8 = {
  class: "pl-4 pr-4"
};
const _hoisted_9 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_10 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_11 = {
  class: "fw-bold fsi-24"
};
const _hoisted_12 = {
  class: "fw-bold fsi-24"
};
const _hoisted_13 = {
  key: 0,
  class: "ml-3"
};
const _hoisted_14 = {
  key: 1,
  class: "ml-3"
};
const _hoisted_15 = {
  key: 2,
  class: "ml-3"
};
const _hoisted_16 = {
  class: "d-flex flex-column align-items-start"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "10px",
    "height": "10px",
    "border-radius": "10px",
    "background-color": "#6752F0",
    "margin-bottom": "10px"
  }
}, null, -1));
const _hoisted_18 = {
  class: "d-flex align-items-center flex-column"
};
const _hoisted_19 = {
  class: "fs-12",
  style: {
    "color": "#6752F0"
  }
};
const _hoisted_20 = {
  style: {
    "font-size": "10px",
    "transform": "scale(0.8)",
    "display": "inline-block",
    "margin-left": "-4px"
  }
};
const _hoisted_21 = {
  class: "fsi-22",
  style: {
    "color": "#101B52"
  }
};
const _hoisted_22 = {
  class: "d-flex align-items-center flex-column mt-2"
};
const _hoisted_23 = ["href"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "12px",
    "color": "white"
  },
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_25 = {
  class: "fsi-22",
  style: {
    "color": "#101B52"
  }
};
const _hoisted_26 = {
  class: "fs-12",
  style: {
    "line-height": "1.5",
    "padding": "0.2rem 0.8rem",
    "background-color": "rgba(103,82,240,0.2)",
    "border-radius": "1rem",
    "display": "inline-block"
  }
};
const _hoisted_27 = {
  class: "flex-center cursor-pointer"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "16px"
  },
  alt: ""
}, null, -1));
const _hoisted_29 = {
  style: {
    "color": "#6752F0"
  },
  class: "ml-1"
};
const _hoisted_30 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_31 = {
  class: "pl-4 pr-4"
};
const _hoisted_32 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_33 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_34 = {
  class: "fw-bold fsi-24"
};
const _hoisted_35 = {
  class: "fw-bold fsi-24"
};
const _hoisted_36 = {
  key: 0,
  style: {
    "margin-left": "-8px"
  }
};
const _hoisted_37 = {
  key: 1,
  style: {
    "margin-left": "-8px"
  }
};
const _hoisted_38 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_39 = {
  class: "col-lg-6 col-12"
};
const _hoisted_40 = {
  class: "pr-4"
};
const _hoisted_41 = {
  class: "pl-4 fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_42 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_43 = {
  class: "pl-4 fw-bold fsi-24"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "10px",
    "height": "10px",
    "border-radius": "10px",
    "background-color": "#6752F0",
    "margin-bottom": "10px"
  }
}, null, -1));
const _hoisted_45 = {
  style: {
    "color": "#1619d7"
  },
  class: "d-flex justify-content-between align-items-center"
};
const _hoisted_46 = {
  style: {
    "min-width": "100px"
  }
};
const _hoisted_47 = {
  class: "fs-12"
};
const _hoisted_48 = {
  style: {
    "color": "#1619d7"
  },
  class: "d-flex justify-content-between align-items-center"
};
const _hoisted_49 = {
  style: {
    "min-width": "100px"
  }
};
const _hoisted_50 = {
  style: {
    "color": "#e86016"
  },
  class: "d-flex align-items-center justify-content-between flex-nowrap mt-1"
};
const _hoisted_51 = {
  style: {
    "min-width": "100px"
  }
};
const _hoisted_52 = {
  class: "fs-12"
};
const _hoisted_53 = {
  style: {
    "color": "#e86016"
  },
  class: "d-flex justify-content-between align-items-center"
};
const _hoisted_54 = {
  style: {
    "min-width": "100px"
  }
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mt-2 mb-2"
}, null, -1));
const _hoisted_56 = {
  class: "d-flex justify-content-between align-items-center"
};
const _hoisted_57 = {
  style: {
    "min-width": "100px"
  }
};
const _hoisted_58 = {
  class: "pl-4 fw-bold fsi-24 cursor-pointer"
};
const _hoisted_59 = {
  key: 0,
  class: "ml-3"
};
const _hoisted_60 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_61 = {
  class: "pl-4 pr-4"
};
const _hoisted_62 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_63 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_64 = {
  class: "fw-bold fsi-24"
};
const _hoisted_65 = {
  class: "fw-bold fsi-24"
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mt-4"
}, null, -1));
const _hoisted_67 = {
  class: "row mt-4"
};
const _hoisted_68 = {
  class: "col-lg-6 col-12"
};
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "10px",
    "height": "10px",
    "border-radius": "10px",
    "background-color": "#6752F0",
    "margin-bottom": "10px"
  }
}, null, -1));
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "1px",
    "background-color": "#dedede"
  },
  class: "mt-2 mb-3"
}, null, -1));
const _hoisted_71 = {
  class: "d-flex justify-content-between align-content-center"
};
const _hoisted_72 = {
  class: "d-flex justify-content-between align-content-center mt-1"
};
const _hoisted_73 = {
  class: "d-flex justify-content-between align-content-center mt-1"
};
const _hoisted_74 = {
  class: "d-flex justify-content-between align-content-center mt-1"
};
const _hoisted_75 = {
  class: "d-flex justify-content-between align-content-center mt-1"
};
const _hoisted_76 = {
  class: "pl-4 pr-4 cursor-pointer"
};
const _hoisted_77 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_78 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "width": "20px",
    "margin-bottom": "3px",
    "cursor": "pointer"
  },
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_80 = {
  class: "fw-bold fsi-24"
};
const _hoisted_81 = {
  class: "fw-bold fsi-24"
};
const _hoisted_82 = {
  key: 0,
  style: {
    "margin-left": "-8px",
    "margin-top": "5px"
  }
};
const _hoisted_83 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_84 = {
  class: "pl-4 pr-4"
};
const _hoisted_85 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_86 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_87 = {
  class: "fw-bold fsi-24"
};
const _hoisted_88 = {
  class: "fw-bold fsi-24"
};
const _hoisted_89 = {
  key: 0,
  style: {
    "margin-top": "5px"
  }
};
const _hoisted_90 = {
  class: "row mt-4"
};
const _hoisted_91 = {
  class: "col-12"
};
const _hoisted_92 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line"
}, null, -1));
const _hoisted_93 = {
  class: "row mt-4"
};
const _hoisted_94 = {
  class: "col-lg-6 col-12"
};
const _hoisted_95 = {
  class: "pl-4 pr-4"
};
const _hoisted_96 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_97 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_98 = {
  key: 0
};
const _hoisted_99 = {
  class: "fw-bold fsi-18"
};
const _hoisted_100 = {
  key: 0,
  style: {
    "margin-left": "-10px"
  }
};
const _hoisted_101 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_102 = {
  class: "pl-4 pr-4"
};
const _hoisted_103 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_104 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_105 = {
  class: "fw-bold fsi-18"
};
const _hoisted_106 = {
  class: "fw-bold fsi-18"
};
const _hoisted_107 = {
  key: 0,
  style: {
    "margin-left": "-10px"
  }
};
const _hoisted_108 = {
  class: "row mt-lg-4 mt-3"
};
const _hoisted_109 = {
  class: "col-lg-6 col-12"
};
const _hoisted_110 = {
  class: "pl-4 pr-4"
};
const _hoisted_111 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_112 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_113 = {
  class: "fw-bold fsi-18"
};
const _hoisted_114 = {
  class: "fw-bold fsi-18"
};
const _hoisted_115 = {
  class: "fw-medium fs-12"
};
const _hoisted_116 = {
  class: "fw-medium fs-12"
};
const _hoisted_117 = {
  class: "fw-medium fs-12"
};
const _hoisted_118 = {
  class: "fw-medium fs-12"
};
const _hoisted_119 = {
  class: "col-lg-6 col-12 mt-lg-0 mt-3"
};
const _hoisted_120 = {
  class: "pl-4 pr-4"
};
const _hoisted_121 = {
  class: "fw-medium fsi-14 d-flex align-items-center",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_122 = {
  class: "mr-1",
  style: {
    "color": "#787A9B"
  }
};
const _hoisted_123 = {
  class: "fw-bold fsi-18"
};
const _hoisted_124 = {
  class: "fw-bold fsi-18"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_AfterValue = _resolveComponent("AfterValue");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_chart_block = _resolveComponent("chart-block");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.Overview')), 1)]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('farm.console.PositionValue')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.PositionValueTip')), 1)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_12, _toDisplayString($options.externalFormatFilPrice(_ctx.currentNode.position_value)), 1)])]),
    _: 1
  }, 8, ["loading"])]), !_ctx.currentLoading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.rightPanelType === 'Borrowing & Repayment' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.positionValue,
    "new-value": _ctx.afterPositionValue
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true), _ctx.rightPanelType === 'Withdraw From Node' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.positionValue,
    "new-value": _ctx.afterPositionValueByWithDraw
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true), _ctx.guaranteeNodeId !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_el_popover, {
    placement: "bottom",
    disabled: _ctx.guaranteeNodeId === 0,
    width: 200,
    trigger: "hover"
  }, {
    reference: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('farm.console.Contains the Position').replace("$$$$", `f0${_ctx.guaranteeNodeId}`)), 1)])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_19, [_createTextVNode(" f0" + _toDisplayString($props.nodeId) + " ", 1), _createElementVNode("span", _hoisted_20, "(" + _toDisplayString(_ctx.$t('farm.console.current')) + ")", 1)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_21, _toDisplayString($options.externalFormatFilPrice(_ctx.guaranteeCurrentPositionValue)), 1)])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", null, [_createElementVNode("a", {
      class: "fs-12",
      style: {
        "color": "#6752F0",
        "cursor": "pointer"
      },
      href: `/#/farm/provider/${_ctx.guaranteeNodeId}`
    }, [_createTextVNode(" f0" + _toDisplayString(_ctx.guaranteeNodeId) + " ", 1), _hoisted_24], 8, _hoisted_23), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_25, _toDisplayString($options.externalFormatFilPrice(_ctx.guaranteePositionValue)), 1)])])])])]),
    _: 1
  }, 8, ["disabled"])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('farm.console.EquityValue')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.EquityValueTip')), 1)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_35, _toDisplayString($options.externalFormatFilPrice(_ctx.equityValue)), 1)]),
    _: 1
  }, 8, ["loading"]), !_ctx.currentLoading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.rightPanelType === 'Borrowing & Repayment' ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.equityValue,
    "new-value": _ctx.afterEquityValue
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true), _ctx.rightPanelType === 'Withdraw From Node' ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.equityValue,
    "new-value": _ctx.afterEquityValueByWithDraw
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('farm.console.DebtValue')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.DebtValueTip')), 1)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_popover, {
      placement: "bottom",
      width: 300,
      trigger: "hover"
    }, {
      reference: _withCtx(() => [_createElementVNode("div", _hoisted_58, _toDisplayString($options.externalFormatFilPrice(_ctx.guaranteeCurrenDebtValue, 4)), 1)]),
      default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_44, _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t('farm.console.VariableDebt')) + ":", 1), _createElementVNode("div", null, [_createTextVNode(_toDisplayString($options.formatWalletFilPrice(_ctx.guaranteeCurrenVariableDebtValue)) + " ", 1), _createElementVNode("span", _hoisted_47, "(" + _toDisplayString($options.formatUnits(_ctx.variableDebtValueProportion, 2)) + "%)", 1)])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('farm.console.VariableInterestRate')) + ":", 1), _createElementVNode("div", null, _toDisplayString($options.formatPrice($options.formatUnits(_ctx.variableBorrowRate, 25), 2)) + "%", 1)]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('farm.console.StableDebt')) + ": ", 1), _createElementVNode("div", null, [_createTextVNode(_toDisplayString($options.formatWalletFilPrice(_ctx.guaranteeCurrenStableDebtValue)) + " ", 1), _createElementVNode("span", _hoisted_52, "(" + _toDisplayString($options.formatUnits(_ctx.stableDebtValueProportion, 2)) + "%)", 1)])]), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('farm.console.StableInterestRate')) + ":", 1), _createElementVNode("div", null, _toDisplayString($options.formatPrice($options.formatUnits(_ctx.userStableRate, 25), 2)) + "%", 1)]), _hoisted_55, _createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('farm.console.avgRate')) + ":", 1), _createElementVNode("div", null, _toDisplayString($options.formatPrice($options.formatUnits(_ctx.userAvgRate, 25), 2)) + "%", 1)])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["loading"]), !_ctx.currentLoading ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.guaranteeCurrenDebtValue,
    "new-value": _ctx.afterCurrentNodeDebtValue
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('farm.console.InterestValue')), 1)]), _createVNode(_component_i_skeleton, {
    loading: $data.nodeInterestLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_64, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_65, _toDisplayString($options.formatWalletFilPrice($data.nodeInterestData)), 1)]),
    _: 1
  }, 8, ["loading"])])])]), _hoisted_66, _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createVNode(_component_el_popover, {
    placement: "bottom",
    width: 370,
    trigger: "hover"
  }, {
    reference: _withCtx(() => [_createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("span", _hoisted_78, [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.CurrentAPR')) + " ", 1), _hoisted_79])]), _createVNode(_component_i_skeleton, {
      loading: _ctx.currentLoading
    }, {
      template: _withCtx(() => [_createElementVNode("div", _hoisted_80, [_createVNode(_component_el_skeleton_item, {
        variant: "h3",
        style: {
          "width": "50%"
        }
      })])]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_81, _toDisplayString(parseFloat($options.formatUnits(_ctx.totalAPR, 2)).toFixed(2)) + "% ", 1)]),
      _: 1
    }, 8, ["loading"]), !_ctx.currentLoading ? (_openBlock(), _createElementBlock("div", _hoisted_82, [_createVNode(_component_AfterValue, {
      "is-eth": false,
      suffix: "%",
      units: 2,
      "old-value": _ctx.totalAPR,
      "new-value": _ctx.afterTotalAPR
    }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true)])]),
    default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_69, _createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.Calculatedbasedonyourleveragedposition')) + " " + _toDisplayString($options.formatUnits(_ctx.currentLeverage, 4)) + " " + _toDisplayString(_ctx.$t('farm.console.Calculatedbasedonyourleveragedposition2')), 1), _hoisted_70, _createElementVNode("div", _hoisted_71, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.CurrentFarmAPR')) + ":", 1), _createElementVNode("div", null, _toDisplayString($options.formatUnits(_ctx.afterCurrentFarmAPR, 2)) + " %", 1)]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.CurrentBorrowingInterestAPR')) + ":", 1), _createElementVNode("div", null, "- " + _toDisplayString($options.formatUnits(_ctx.afterCurrentBorrowingInterestAPR, 2)) + " %", 1)]), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.TotalAPR')) + ":", 1), _createElementVNode("div", null, _toDisplayString($options.formatUnits(_ctx.afterTotalAPR, 2)) + " %", 1)]), _createElementVNode("div", _hoisted_74, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.DailyAPR')) + ":", 1), _createElementVNode("div", null, _toDisplayString($options.formatPrice($options.formatUnits(_ctx.afterDailyAPR, 6), 4)) + " %", 1)]), _createElementVNode("div", _hoisted_75, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.EstimatedDailyEarnings')) + ":", 1), _createElementVNode("div", null, _toDisplayString($options.externalFormatFilPrice(_ctx.afterEstimatedDailyEarnings)), 1)])])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, [_createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.$t('farm.console.EstimatedDailyEarnings')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_87, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_88, _toDisplayString($options.externalFormatFilPrice(_ctx.estimatedDailyEarnings, 4)), 1)]),
    _: 1
  }, 8, ["loading"]), !_ctx.currentLoading ? (_openBlock(), _createElementBlock("div", _hoisted_89, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.estimatedDailyEarnings,
    "new-value": _ctx.afterEstimatedDailyEarnings
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_90, [_createElementVNode("div", _hoisted_91, [_createVNode(_component_chart_block, {
    height: "400px",
    showTools: false,
    option: $data.optionInterestRateMode
  }, null, 8, ["option"])])]), _hoisted_92, _createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [_createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.$t('farm.console.DebtRatio')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('farm.console.DebtRatioTip')), 1), _ctx.guaranteeNodeId !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString(_ctx.$t('farm.console.DebtRatioTip2')), 1)) : _createCommentVNode("", true)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_99, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["fw-bold fsi-18", $options.debtRatioColor(_ctx.debtRatio, _ctx.maxDebtRatio)])
    }, _toDisplayString($options.formatUnits(_ctx.debtRatio, 2)) + "% ", 3)]),
    _: 1
  }, 8, ["loading"]), !_ctx.currentLoading ? (_openBlock(), _createElementBlock("div", _hoisted_100, [_ctx.rightPanelType === 'Borrowing & Repayment' ? (_openBlock(), _createBlock(_component_AfterValue, {
    key: 0,
    "is-eth": false,
    suffix: "%",
    units: 2,
    "old-value": _ctx.debtRatio,
    "new-value": _ctx.afterDebtRatio
  }, null, 8, ["old-value", "new-value"])) : _createCommentVNode("", true), _ctx.rightPanelType === 'Withdraw From Node' ? (_openBlock(), _createBlock(_component_AfterValue, {
    key: 1,
    "is-eth": false,
    suffix: "%",
    units: 2,
    "old-value": _ctx.debtRatio,
    "new-value": _ctx.afterDebtRatioByWithdraw
  }, null, 8, ["old-value", "new-value"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, [_createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.$t('farm.console.SafetyBuffer')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.SafetyBufferTip')), 1)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_105, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_106, _toDisplayString($options.externalFormatFilPrice(_ctx.safetyBuffer)), 1)]),
    _: 1
  }, 8, ["loading"]), !_ctx.currentLoading ? (_openBlock(), _createElementBlock("div", _hoisted_107, [_createVNode(_component_AfterValue, {
    "old-value": _ctx.safetyBuffer,
    "new-value": _ctx.afterSafetyBuffer
  }, null, 8, ["old-value", "new-value"])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("div", _hoisted_110, [_createElementVNode("div", _hoisted_111, [_createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.$t('farm.console.MaximumDebtRatio')), 1)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_113, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_114, _toDisplayString($options.formatUnits(_ctx.maxDebtRatio, 2)) + "%", 1)]),
    _: 1
  }, 8, ["loading"]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_115, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.$t('farm.console.MaximumLeverage')) + ": " + _toDisplayString($options.formatUnits(_ctx.currentNode.max_leverage, 4)) + "x ", 1)]),
    _: 1
  }, 8, ["loading"]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_117, [_createVNode(_component_el_skeleton_item, {
      variant: "h4",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.$t('farm.console.Delegated')) + ": " + _toDisplayString(_ctx.role), 1)]),
    _: 1
  }, 8, ["loading"])])]), _createElementVNode("div", _hoisted_119, [_createElementVNode("div", _hoisted_120, [_createElementVNode("div", _hoisted_121, [_createElementVNode("span", _hoisted_122, _toDisplayString(_ctx.$t('farm.console.LiqThreshold')), 1), _createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('farm.console.LiqThresholdTip')), 1)]),
    _: 1
  })]), _createVNode(_component_i_skeleton, {
    loading: _ctx.currentLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_123, [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "width": "50%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_124, _toDisplayString($options.formatUnits(_ctx.currentNode.liquidation_threshold, 2)) + "%", 1)]),
    _: 1
  }, 8, ["loading"])])])])])]);
}